import { List, ListItemText, ListItem, tokens } from '@sapphire-react/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  languages: ('se' | 'fi' | 'en')[];
};

const languageConfigs = {
  se: {
    primary: 'Swedish',
    secondary: 'Default language',
    emoji: '🇸🇪',
  },
  fi: {
    primary: 'Finnish',
    secondary: 'Default language',
    emoji: '🇫🇮',
  },
  en: {
    primary: 'English',
    secondary: 'English language',
    emoji: '🇬🇧',
  },
};

export const displayLanguageSwitcher =
  window.location.hostname.includes('syst-www') ||
  process.env.NODE_ENV === 'development';

export const DevLanguageSwitcher = ({ languages }: Props) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const keyDownHandler = (e: KeyboardEvent) => {
      if (e.altKey && e.shiftKey && e.code === 'KeyD') {
        setIsOpen(!isOpen);
      }

      if (e.code === 'Escape') {
        setIsOpen(false);
      }
    };

    window.addEventListener('keydown', keyDownHandler);
    return () => {
      window.removeEventListener('keydown', keyDownHandler);
    };
  }, [isOpen, setIsOpen]);

  return (
    <List
      isHidden={!isOpen}
      position={'absolute'}
      zIndex={101}
      UNSAFE_style={{
        backgroundColor: tokens.color.backgroundSurface.value,
        boxShadow: `5px 5px 5px ${tokens.color.borderFieldDefault.value}`,
      }}
    >
      {languages.map((lang) => (
        <ListItem key={lang}>
          <ListItem.Button onPress={() => i18n.changeLanguage(lang)}>
            <ListItem.Content
              contentRight={languageConfigs[lang].emoji}
              contentLeft={
                <ListItemText
                  primary={languageConfigs[lang].primary}
                  secondary={languageConfigs[lang].secondary}
                />
              }
            />
          </ListItem.Button>
        </ListItem>
      ))}
      <ListItem>
        <ListItem.Button onPress={() => i18n.changeLanguage('cimode')}>
          <ListItem.Content
            contentRight={'🏴‍☠️'}
            contentLeft={
              <ListItemText
                primary={'Translation Mode'}
                secondary={'Use to see the translation keys'}
              />
            }
          />
        </ListItem.Button>
      </ListItem>
    </List>
  );
};
